import { Badge } from "react-bootstrap";
import { ServerRequestsMonthlyPlateAssociation, ServerRequestsMonthlyPlateMatch } from "../../shared/api/axios-client";

function isAccountOnly(association: ServerRequestsMonthlyPlateAssociation | undefined): boolean {
    return association === ServerRequestsMonthlyPlateAssociation.AccountOnly;
}

function initials(name: string): string {
    const parts = name.trim().split(/\s+/).filter((word) => /[A-Za-z]/.test(word));
    if (parts.length === 0) return "?";
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[1][0]).toUpperCase();
}

export interface MonthlyPlateMatchListProps {
    matches: ServerRequestsMonthlyPlateMatch[];
}

export function MonthlyPlateMatchList({ matches }: MonthlyPlateMatchListProps) {
    if (matches.length === 0) return null;

    return (
        <div className="mb-3">
            <div
                className="text-muted fw-semibold mb-2"
                style={{ fontSize: "0.7rem", letterSpacing: "0.08em" }}
            >
                MATCHES
            </div>
            <div className="d-flex flex-column gap-2">
                {matches.map((match) => {
                    const accountOnly = isAccountOnly(match.association);
                    const plan = match.planName || "—";
                    return (
                        <div
                            key={`${match.subscriptionId}-${match.parkerId}`}
                            className="d-flex align-items-start gap-3 rounded-3 bg-white px-3 py-2"
                            style={{ border: "1px solid #e9ecef" }}
                        >
                            <div
                                className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 fw-semibold"
                                style={{
                                    width: 40,
                                    height: 40,
                                    background: "#efe7fb",
                                    color: "#6d28d9",
                                    fontSize: "0.85rem",
                                }}
                            >
                                {initials(match.parkerName || "")}
                            </div>
                            <div className="flex-grow-1" style={{ minWidth: 0 }}>
                                <div className="fw-semibold">{match.parkerName || "—"}</div>
                                <div className="text-muted small">
                                    {accountOnly ? plan : `${plan} · Linked account`}
                                </div>
                                <div className="d-flex flex-wrap align-items-center gap-1 mt-1">
                                    {accountOnly && (
                                        <Badge
                                            bg=""
                                            className="fw-semibold"
                                            style={{ background: "#fde8c8", color: "#9a6700" }}
                                        >
                                            Not linked
                                        </Badge>
                                    )}
                                    <Badge
                                        bg=""
                                        className="fw-semibold"
                                        style={{ background: "#d9f5e5", color: "#157347" }}
                                    >
                                        Active
                                    </Badge>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
